export const BOOKING_VIRAL_HUBS_CTA = 'booking-page-signup-visual';
export const THANKYOU_VIRAL_HUBS_CTA = 'thank-you-page-signup-visual';

// These exact hostnames are compared against the current window host to redirect
// legacy www.* hosts to their app.* equivalents, so they must stay hardcoded
// rather than being generated by hubspot-url-utils.
// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
export const wrongHubSpotDomain = 'www.hubspot.com';

// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
export const wrongHubSpotQADomain = 'www.hubspotqa.com';

// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
export const hubSpotDomain = 'app.hubspot.com';

// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
export const hubSpotQADomain = 'app.hubspotqa.com';